
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { memo, useRef, useState, useLayoutEffect } from 'react';
import Tooltip from '../../Tooltip/Tooltip.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["children", "as", "maxWidth", "windowWidth", "windowHeight", "onClick"];
var Cell = function Cell(_ref) {
  var children = _ref.children,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? "td" : _ref$as,
    maxWidth = _ref.maxWidth,
    windowWidth = _ref.windowWidth,
    windowHeight = _ref.windowHeight,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var componentRef = useRef(null);
  var overflowRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowActive = _useState2[0],
    setIsOverflowActive = _useState2[1];
  var isRowCell = Component === "td";
  var shouldRenderTooltip = Boolean(Component === "td" && maxWidth);
  var style = isRowCell ? {
    maxWidth: maxWidth ? "".concat(maxWidth, "px") : "auto"
  } // row cell styles
  : {
    width: maxWidth ? "".concat(maxWidth, "px") : "auto"
  }; // column cell styles

  useLayoutEffect(function () {
    // determine if the row cell is overflown on initial render
    if (shouldRenderTooltip && componentRef.current) {
      var element = componentRef.current.querySelector(".has-overflow");
      if (element) {
        var el = element;
        overflowRef.current = el;
        setIsOverflowActive(el.offsetWidth < el.scrollWidth);
      }
    }
  }, []);
  useLayoutEffect(function () {
    // determine if the row cell is overflown on window width or height change
    if (shouldRenderTooltip) {
      var el = overflowRef.current;
      if (el) setIsOverflowActive(el.offsetWidth < el.scrollWidth);
    }
  }, [windowWidth, windowHeight]);
  return jsx(Component, _extends({
    ref: componentRef,
    style: style,
    onClick: onClick
  }, rest), shouldRenderTooltip ? jsx(Tooltip, {
    content: children,
    disabled: !isOverflowActive
  }, jsx("span", {
    style: style
  }, children)) : children);
};
var Cell$1 = /*#__PURE__*/memo(Cell);

export { Cell$1 as default };
//# sourceMappingURL=Cell.js.map
